"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.split");
var _slicedToArray2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
var _AllianceSetupCommn = _interopRequireDefault(require("@/views/allianceAuthorization/components/AllianceSetupCommn.vue"));
var _allianceAuthorization = require("@/api/allianceAuthorization");
var _DataSource = require("@/views/allianceAuthorization/components/DataSource.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: '',
  components: {
    AllianceSetup: _AllianceSetupCommn.default
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    platformCode: {
      type: String,
      default: ''
    },
    queryData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      showDialog: true,
      loading: false,
      tableData: [],
      page: 1,
      size: 10,
      total: 0,
      optionsData: {}
    };
  },
  created: function created() {
    this.optionsData = _DataSource.optionsData;
    this.getAllianceConfig();
  },
  mounted: function mounted() {
    var allianceAuthorizationCode = localStorage.getItem('KSallianceAuthorizationCode') ? JSON.parse(localStorage.getItem('KSallianceAuthorizationCode')) : '';
    if (this.queryData.code && this.queryData.code !== allianceAuthorizationCode) {
      localStorage.setItem('KSallianceAuthorizationCode', JSON.stringify(this.queryData.code));
      this.getAccessToken();
    }
  },
  methods: {
    TimeConversion: function TimeConversion(dateStr, secondsToAdd) {
      if (!dateStr) return;
      // 解析日期字符串为本地时间
      var _dateStr$split = dateStr.split(' '),
        _dateStr$split2 = (0, _slicedToArray2.default)(_dateStr$split, 2),
        datePart = _dateStr$split2[0],
        timePart = _dateStr$split2[1];
      var _datePart$split$map = datePart.split('-').map(Number),
        _datePart$split$map2 = (0, _slicedToArray2.default)(_datePart$split$map, 3),
        year = _datePart$split$map2[0],
        month = _datePart$split$map2[1],
        day = _datePart$split$map2[2];
      var _timePart$split$map = timePart.split(':').map(Number),
        _timePart$split$map2 = (0, _slicedToArray2.default)(_timePart$split$map, 3),
        hours = _timePart$split$map2[0],
        minutes = _timePart$split$map2[1],
        seconds = _timePart$split$map2[2];

      // 创建 Date 对象（月份从 0 开始）
      var originalDate = new Date(year, month - 1, day, hours, minutes, seconds);

      // 计算新时间戳并转换回日期
      var newTimestamp = originalDate.getTime() + secondsToAdd * 1000;
      var newDate = new Date(newTimestamp);

      // 格式化为 YYYY-MM-DD HH:mm:ss
      var pad = function pad(n) {
        return n.toString().padStart(2, '0');
      };
      return [newDate.getFullYear(), pad(newDate.getMonth() + 1), pad(newDate.getDate())].join('-') + ' ' + [pad(newDate.getHours()), pad(newDate.getMinutes()), pad(newDate.getSeconds())].join(':');
    },
    // 更新授权
    UpdateAuthorization: function UpdateAuthorization(data) {
      var redirect_uri = encodeURIComponent('https://admin.ug.changfukeji.com/allianceAuthorization/KSAllianceAuthorization' + "?id=".concat(data.id));
      console.log('redirect_uri,', redirect_uri);
      var url = "https://open.kuaishou.com/oauth2/authorize?app_id=".concat(data.apiAppKey, "&redirect_uri=").concat(redirect_uri, "&scope=merchant_distribution,merchant_item,merchant_order,user_info,merchant_user&response_type=code");
      // window.open(url, '_blank')
      location.href = url;
    },
    getAccessToken: function () {
      var _getAccessToken = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                id: this.queryData.id,
                code: this.queryData.code,
                platformCode: this.platformCode
              };
              _context.n = 1;
              return (0, _allianceAuthorization.accessToken)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.$message.success('获取授权成功');
                this.getAllianceConfig();
              } else {
                this.$message.error('获取授权失败');
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getAccessToken() {
        return _getAccessToken.apply(this, arguments);
      }
      return getAccessToken;
    }(),
    Screening: function Screening(data, val) {
      var obj = data.find(function (item) {
        return item.value === val;
      });
      return obj ? obj.label : val;
    },
    onAdd: function onAdd() {
      this.$refs.allianceSetup.open({
        type: 'add',
        name: this.name,
        platformCode: this.platformCode
      });
    },
    onEditor: function onEditor(data) {
      this.$refs.allianceSetup.open({
        type: 'editor',
        name: this.name,
        platformCode: this.platformCode,
        data: data
      });
    },
    onDel: function onDel(id) {
      var _this = this;
      this.$confirm('确认删除联盟账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.deleteAllianceConfig(id);
      });
    },
    onRefresh: function onRefresh() {
      this.getAllianceConfig();
    },
    onSetDefault: function onSetDefault(id) {
      var _this2 = this;
      this.$confirm('默认联盟账号更换或导致订单丢失请谨慎操作！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.setDefaultConfig(id);
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.size = val;
      this.getAllianceConfig();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getAllianceConfig();
    },
    getAllianceConfig: function () {
      var _getAllianceConfig2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading = true;
              _context2.p = 1;
              params = {
                platformCode: this.platformCode,
                page: {
                  page: this.page,
                  size: this.size
                }
              };
              _context2.n = 2;
              return (0, _allianceAuthorization.getAllianceConfig)(params);
            case 2:
              res = _context2.v;
              if (res.code === 0) {
                console.log(res.data);
                this.tableData = res.data.records;
                this.total = res.data.total;
              }
              this.loading = false;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              this.loading = false;
              console.log(_t);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function getAllianceConfig() {
        return _getAllianceConfig2.apply(this, arguments);
      }
      return getAllianceConfig;
    }(),
    deleteAllianceConfig: function () {
      var _deleteAllianceConfig2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(id) {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.loading = true;
              _context3.p = 1;
              params = {
                id: id
              };
              _context3.n = 2;
              return (0, _allianceAuthorization.deleteAllianceConfig)(params);
            case 2:
              res = _context3.v;
              if (res.code === 0) {
                this.$message.success('删除成功');
                this.getAllianceConfig();
              }
              this.loading = false;
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              this.loading = false;
              console.log(_t2);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function deleteAllianceConfig(_x) {
        return _deleteAllianceConfig2.apply(this, arguments);
      }
      return deleteAllianceConfig;
    }(),
    setDefaultConfig: function () {
      var _setDefaultConfig2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(id) {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.loading = true;
              _context4.p = 1;
              params = {
                id: id,
                defaultFlag: 1
              };
              _context4.n = 2;
              return (0, _allianceAuthorization.setDefaultConfig)(params);
            case 2:
              res = _context4.v;
              if (res.code === 0) {
                this.$message.success('设置成功');
                this.getAllianceConfig();
              }
              this.loading = false;
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              this.loading = false;
              console.log(_t3);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function setDefaultConfig(_x2) {
        return _setDefaultConfig2.apply(this, arguments);
      }
      return setDefaultConfig;
    }()
  }
};